import React from 'react';
import { Box, Typography } from '@mui/material';
import CustomSwitch from './CustomSwitch';

/**
 * Title (+ optional subtitle) on the left, iOS-style switch on the right.
 * Shared by editor overflow menus and listing management modals.
 */
const LabeledToggleRow = ({
  title,
  subtitle,
  checked,
  disabled = false,
  sx,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1.5,
      width: '100%',
      minWidth: 0,
      ...sx,
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography
        sx={{
          fontSize: '0.875rem',
          fontWeight: subtitle ? 600 : 400,
          lineHeight: 1.3,
          color: 'rgba(0,0,0,0.88)',
        }}
      >
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            fontSize: '0.72rem',
            color: 'rgba(0,0,0,0.5)',
            lineHeight: 1.45,
            mt: 0.15,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
    <Box sx={{ flexShrink: 0, opacity: disabled ? 0.55 : 1 }}>
      <CustomSwitch checked={checked} onClick={() => {}} />
    </Box>
  </Box>
);

export default LabeledToggleRow;
